package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class RenameDayTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(
        workplaceId: String,
        templateId: String,
        newName: String
    ): Result<Unit> {
        return try {
            val templates = workplaceRepository.getDayTemplates(workplaceId).getOrThrow()
            val template = templates.find { it.id == templateId }
                ?: return Result.failure(Exception("Template not found"))

            val updatedTemplate = template.copy(name = newName)
            workplaceRepository.updateDayTemplate(workplaceId, updatedTemplate)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}

class DeleteDayTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    /** Deletes the template and clears the weekdays of the skeleton that pointed at it. */
    suspend operator fun invoke(workplaceId: String, templateId: String): Result<Unit> = runCatching {
        val workplace = workplaceRepository.getWorkplace(workplaceId).getOrThrow()
        val skeleton = workplace.settings.defaultWeeklySkeleton
        if (skeleton.containsValue(templateId)) {
            workplaceRepository.updateWeeklySkeleton(workplaceId, skeleton.filterValues { it != templateId }).getOrThrow()
        }
        workplaceRepository.deleteDayTemplate(workplaceId, templateId).getOrThrow()
    }
}

class DuplicateDayTemplateUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(workplaceId: String, templateId: String): Result<String> {
        return try {
            val templates = workplaceRepository.getDayTemplates(workplaceId).getOrThrow()
            val original = templates.find { it.id == templateId }
                ?: return Result.failure(Exception("Template not found"))

            val newName = "${original.name} (Copy)"
            val newTemplate =
                original.copy(id = "", name = newName) // ID zostanie nadane przez repo

            workplaceRepository.createDayTemplate(workplaceId, newTemplate)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}